enum Role {
  AGENT_ADMIN = "AGENTADMIN",
  AGENT = "AGENT",
  SALES = "SALES",
  SIGN = "SIGN",
  RESET_PASSWORD = "RESETPASSWORD",
  CLOSE = "CLOSE",
}

export default Role;
